// extracted by mini-css-extract-plugin
export default {"productMenu":"ProductMenu_productMenu__rQ+b-","navItems":"ProductMenu_navItems__tED+z","navLink":"ProductMenu_navLink__ypaoD","active":"ProductMenu_active__USXbi"};